class AssetSummary {
  constructor($element, onSearchCallback, onClearCallback) {
    this.domElement = $element;
    this.onSearchCallback = onSearchCallback;
    this.onClearCallback = onClearCallback;
  }

  updateSummary(data_summary, filters) {
    this.domElement.empty();

    this.domElement.append('<h3>Project Summary</h3>');

    const $clearButton = $(
      '<button name="button" id="clear-filters" class="button">Clear Filters</button>',
    );
    $clearButton.click(() => {
      return this.onClearCallback();
    });

    this.domElement.append('<h6>Click on the rows to filter the assets.</h6>');
    this.domElement.append($clearButton);

    return (() => {
      const result = [];
      const iterable = data_summary || [];
      for (let field_index = 0; field_index < iterable.length; field_index++) {
        var field_summary_data = iterable[field_index];
        var { method_name } = field_summary_data;
        var $table = $(`<table class='table--summary'> \
<thead> \
<th class='th--value'>${field_summary_data.display_name}</th> \
<th class='th--count'></th> \
</thead></table>`);
        for (
          var value_index = 0;
          value_index < field_summary_data.field_counts.length;
          value_index++
        ) {
          var rowClass;
          var value_set = field_summary_data.field_counts[value_index];
          if (filters[method_name] && filters[method_name].length > 0) {
            rowClass = 'filtered';
          } else {
            rowClass = '';
          }
          var $row = $(`\
<tr class='attribute ${rowClass}'> \
<td class='td--value'>${value_set.display_value}</td> \
<td class='td--count'>${value_set.count}</td> \
</tr>`);

          this.setFilterClickEvent(
            $row,
            field_summary_data.method_name,
            value_set.filter_value,
          );

          $table.append($row);
        }

        result.push(this.domElement.append($table));
      }
      return result;
    })();
  }

  setFilterClickEvent($row, name, value) {
    return $row.click(() => {
      return this.onSearchCallback($row, name, value);
    });
  }
}

//-----------  Export  -----------#
module.exports = AssetSummary;
